import axiosInstance from "services/restful.service";

export const fetchReport = () => {
  return axiosInstance.get("");
};
